import {strEnum} from "../../types";
import { IMetrics } from "../api-metrics";
import {IInstanceInfo} from "../app-manager";

export const HybridAgentStatusType = strEnum(["healthy", "heartbeatLost"]);
export type HybridAgentStatusType = keyof typeof HybridAgentStatusType;

/**
 * interface IHybridAgentList
 */
export interface IHybridAgentList {
    id: string;
    name: string;
    status: HybridAgentStatusType;
    machine: string;
    version: string;
    gsbc: string;
    lastContact: number;
    lastStartup: number;
    tunnelAccessKey: string;
}

/**
 * interface IHybridAgentSpecList
 */

export interface IHybridAgentSpecList {
    specs: string[];
}
// tslint:disable-next-line:no-empty-interface
export interface IHybridMetrics extends IMetrics {
}

export interface IHybridInstanceStatus {
    id: string;
    appStatus: string;
    instances: number;
    desiredInstances: number;
    failedInstances: number;
    startingInstances: number;
    heartbeatLostInstances: number;
    instancesInfo: IInstanceInfo[];
}
